import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Markdown, UnderstandButton, ContentWrapper as Content } from './privacyOverlay.styles';
import { Overlay } from '../overlay';
import { renderWhenTrue } from '../../utils/rendering';
import messages from './privacyOverlay.messages';
import { AnimatedOverlay } from '../animatedOverlay';
import { HashRoute } from '../hashRoute';

export class PrivacyOverlay extends PureComponent {
  static propTypes = {
    intl: PropTypes.object,
    isVisible: PropTypes.bool,
    isStandalone: PropTypes.bool,
    content: PropTypes.string,
    fetchPrivacy: PropTypes.func.isRequired,
    showOverlay: PropTypes.func.isRequired,
    hideOverlay: PropTypes.func.isRequired,
  };

  componentDidMount() {
    this.props.fetchPrivacy();
  }

  get headerTitle() {
    return this.props.intl.formatMessage(messages.title);
  }

  handleOpen = () => this.props.showOverlay();
  handleClose = () => this.props.hideOverlay();

  renderButton = () => (
    <UnderstandButton label={this.props.intl.formatMessage(messages.button)} onClick={this.handleClose} />
  );

  render() {
    return (
      <Fragment>
        <HashRoute
          hashName="privacy"
          isActive={this.props.isVisible && !this.props.isStandalone}
          onLeave={this.handleClose}
          onEnter={this.handleOpen}
        />
        <AnimatedOverlay visible={this.props.isVisible} disableAnimation={this.props.isStandalone}>
          <Overlay title={this.headerTitle} onClose={this.props.isStandalone ? null : this.handleClose}>
            <Content>
              <Markdown>{this.props.content}</Markdown>
              {renderWhenTrue(this.renderButton)(!this.props.isStandalone)}
            </Content>
          </Overlay>
        </AnimatedOverlay>
      </Fragment>
    );
  }
}
